define.alias("shared/helpers/format-profile-categorization-value", "calendar/helpers/format-profile-categorization-value");